import React from 'react';
import Styled, { keyframes } from 'styled-components';

const SvgWrapper = Styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const offset = 120;
const duration = '.8s';

const Rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(270deg); }
`;

const Dash = keyframes`
  0% {
    stroke-dashoffset: ${offset};
  }
  50% {
    stroke-dashoffset: ${offset / 4};
    transform:rotate(135deg);
  }
  100% {
    stroke-dashoffset: ${offset};
    transform:rotate(450deg);
  }
`;

const Svg = Styled.svg`
  animation: ${Rotate} ${duration} linear infinite;
`;

const Circle = Styled.circle`
  stroke-dasharray: ${offset};
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: ${Dash} ${duration} ease-in-out infinite;
`;

export default ({ size = 50 }) => (
  <SvgWrapper>
    <Svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle
        stroke="#0069b4"
        fill="none"
        strokeWidth="4"
        strokeLinecap="round"
        cx={size / 2}
        cy={size / 2}
        r={size / 2 - 2}
      />
    </Svg>
  </SvgWrapper>
);
